module.exports = __webpack_public_path__ + "static/media/circular-levels-icon.f58f2786.svg";